var FuzzyReaction = require('../bootstrap').FuzzyReaction;
var AppDispatcher = FuzzyReaction.Dispatcher;
var AppActionConstants = require('../constants/AppActionConstants');
var assign = require('object-assign');
var ModelStore = FuzzyReaction.Stores.ModelStore;

var ActionTypes = AppActionConstants.ActionTypes.menuUrls;

/**
 * Data stores
 * @type {Array}
 * @private
 */
// Store for menu table data
var _listData = [];

/**
 * MenuUrl store logic
 *
 * @type {*|exports}
 */
var MenuUrlStore = assign({}, ModelStore, {
	getMenuUrlData: function () {
		return _listData;
	}
});

/**
 * Event Listeners
 */
MenuUrlStore.dispatchToken = AppDispatcher.register(function (action) {
	switch (action.type) {
		case 'MENU-ITEMS_LISTED':
			_listData = action.data;

			MenuUrlStore.emitChange();
			break;
		case ActionTypes.UPDATED_MENUURLSS:
			MenuUrlStore.emitChange();
			break;

	}
});

module.exports = MenuUrlStore;
